module.exports = __webpack_public_path__ + "static/media/about-icon-polite.91caca29.svg";